module.exports = __webpack_public_path__ + "static/media/AP_NES_Z1.5e729cee.png";